<template>
    <div class="h-full w-full flex flex-col">
        <InterviewForm mode="create" @created="$emit('created')" @close="$emit('close')" @view-student-profile="viewStudentProfile" />
    </div>
</template>

<script>
import InterviewForm from "./form.vue";
export default {
    name: "interview-create",
    emits: ["created", "close", "view-student-profile"],
    components: { InterviewForm, },
    methods: {
        viewStudentProfile(studentId) {
            this.$emit('view-student-profile', studentId);
        }
    },
}
</script>